// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"194":"d4b9918e","565":"01c44690","820":"5f055575","822":"cf87bb77","953":"5d0efb4e"}[chunkId] + ".css";
};